module.exports = __webpack_public_path__ + "static/media/uzbekistan-small.904fe768.jpg";